<template>
    <div class="shop-index-container">
        <div class="box-card">
            <div class="margin-bottom-sm text-left" style="font-size: 24px;">{{ $t('index.shopIndex.todayData') }}</div>
            <!-- 第一行：今日和周数据 -->
            <el-row :gutter="20" class="margin-bottom">
                <el-col :span="4">
                    <el-card class="data-card" shadow="hover">
                        <div class="text-center" style="height:100px;">
                            <div style="font-size: 32px;font-weight: 600;color: #1acda1;">
                                {{ shopIndexInfo.todayOrderCount || 0 }}</div>
                            <div class="margin-top-lg" style="font-size: 14px;font-weight: 100;">
                                日订单数
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="4">
                    <el-card class="data-card" shadow="hover">
                        <div class="text-center" style="height:100px;">
                            <div style="font-size: 32px;font-weight: 600;color: #3a68f2;">
                                ￥{{ (shopIndexInfo.todayMoney || 0).toFixed(2) }}</div>
                            <div class="margin-top-lg" style="font-size: 14px;font-weight: 100;">
                                日订单金额
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="4">
                    <el-card class="data-card" shadow="hover">
                        <div class="text-center" style="height:100px;">
                            <div style="font-size: 32px;font-weight: 600;color: #ff7911;">
                                {{ shopIndexInfo.todayReturnOrderCount || 0 }}</div>
                            <div class="margin-top-lg" style="font-size: 14px;font-weight: 100;">
                                日退货订单
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="4">
                    <el-card class="data-card" shadow="hover">
                        <div class="text-center" style="height:100px;">
                            <div style="font-size: 32px;font-weight: 600;color: #ffae11;">
                                {{ shopIndexInfo.weekOrderCount || 0 }}</div>
                            <div class="margin-top-lg" style="font-size: 14px;font-weight: 100;">
                                周订单数
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="4">
                    <el-card class="data-card" shadow="hover">
                        <div class="text-center" style="height:100px;">
                            <div style="font-size: 32px;font-weight: 600;color: #1acda1;">
                                ￥{{ (shopIndexInfo.weekOrderAmount || 0).toFixed(2) }}</div>
                            <div class="margin-top-lg" style="font-size: 14px;font-weight: 100;">
                                周订单金额
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="4">
                    <el-card class="data-card" shadow="hover">
                        <div class="text-center" style="height:100px;">
                            <div style="font-size: 32px;font-weight: 600;color: #ff7911;">
                                {{ shopIndexInfo.weekReturnOrderCount || 0 }}</div>
                            <div class="margin-top-lg" style="font-size: 14px;font-weight: 100;">
                                周退货订单
                            </div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
            <!-- 第二行：月数据和其他 -->
            <el-row :gutter="20" class="margin-bottom">
                <el-col :span="4">
                    <el-card class="data-card" shadow="hover">
                        <div class="text-center" style="height:100px;">
                            <div style="font-size: 32px;font-weight: 600;color: #3a68f2;">
                                ￥{{ (shopIndexInfo.monthOrderAmount || 0).toFixed(2) }}</div>
                            <div class="margin-top-lg" style="font-size: 14px;font-weight: 100;">
                                月订单金额
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="4">
                    <el-card class="data-card" shadow="hover">
                        <div class="text-center" style="height:100px;">
                            <div style="font-size: 32px;font-weight: 600;color: #1acda1;">
                                {{ shopIndexInfo.monthOrderCount || 0 }}</div>
                            <div class="margin-top-lg" style="font-size: 14px;font-weight: 100;">
                                月订单数
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="4">
                    <el-card class="data-card" shadow="hover">
                        <div class="text-center" style="height:100px;">
                            <div style="font-size: 32px;font-weight: 600;color: #ff7911;">
                                {{ shopIndexInfo.monthReturnOrderCount || 0 }}</div>
                            <div class="margin-top-lg" style="font-size: 14px;font-weight: 100;">
                                月退货订单
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="4">
                    <el-card class="data-card" shadow="hover">
                        <div class="text-center" style="height:100px;">
                            <div style="font-size: 32px;font-weight: 600;color: #1acda1;">
                                {{ shopIndexInfo.shopVisitCount || 0 }}</div>
                            <div class="margin-top-lg" style="font-size: 14px;font-weight: 100;">
                                {{ $t('index.shopIndex.shopVisitCount') }}
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="4">
                    <el-card class="data-card" shadow="hover">
                        <div class="text-center" style="height:100px;">
                            <div style="font-size: 32px;font-weight: 600;color: #ffae11;">
                                {{ shopIndexInfo.waitShopOrderCount || 0 }}</div>
                            <div class="margin-top-lg" style="font-size: 14px;font-weight: 100;">
                                {{ $t('index.shopIndex.waitShopOrderCount') }}
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="4">
                    <el-card class="data-card" shadow="hover">
                        <div class="text-center" style="height:100px;">
                            <div style="font-size: 32px;font-weight: 600;color: #ff7911;">
                                {{ shopIndexInfo.returnOrderCount || 0 }}</div>
                            <div class="margin-top-lg" style="font-size: 14px;font-weight: 100;">
                                {{ $t('index.shopIndex.returnOrderCount') }}
                            </div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>

            <el-row :gutter="20" class="">
                <el-col :span="12">
                    <el-card class="chart-card">
                        <div slot="header" class="flex justify-between">
                            <span>{{ $t('index.shopIndex.hotProducts') }}</span>
                        </div>
                        <el-table :data="shopIndexInfo.products" border style="width: 100%" v-loading="loading">
                            <el-table-column prop="productId" :label="$t('index.shopIndex.productId')" align="center">
                            </el-table-column>
                            <el-table-column prop="prodName" :label="$t('index.shopIndex.productName')" align="center">
                            </el-table-column>
                            <el-table-column prop="specName" label="规格" align="center">
                            </el-table-column>
                            <el-table-column prop="sales" :label="$t('index.shopIndex.purchaseQuantity')"
                                align="center">
                            </el-table-column>
                        </el-table>
                    </el-card>
                </el-col>
                <el-col :span="12">
                    <el-card class="chart-card">
                        <div slot="header" class="flex justify-between">
                            <span>{{ $t('index.shopIndex.userVisit') }}</span>
                        </div>
                        <div id="userEchatjs" style="height:400px;width: 100%;"></div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import { queryHotProduct, getTodayData } from '@/api/user/indexApi'
import { getShopId } from '@/api/shop/shopApi'
import * as echarts from 'echarts'

export default {
    name: 'ShopIndexList',
    data() {
        return {
            loading: false,
            shopIndexInfo: {
                products: [],
                shopVisitCount: '',
                waitShopOrderCount: '',
                returnOrderCount: '',
                todayMoney: '',
                sevenDay: [],
                sevenDayDatas: []
            },
            communityId: ''
        }
    },
    created() {
        this.shopId = getShopId()
        if (this.shopId) {
            this.queryHotProduct()
            this.getTodayData()
        }
    },
    methods: {
        async queryHotProduct() {
            try {
                this.loading = true
                const params = {
                    page: 1,
                    row: 10,
                    shopId: this.shopId
                }
                const { data } = await queryHotProduct(params)
                if (data) {
                    data.forEach(product => {
                        let _productSpecValues = product.productSpecValues
                        if (_productSpecValues) {
                            _productSpecValues.forEach(item => {
                                let _productSpecDetails = item.productSpecDetails
                                let _specValue = ''
                                if (_productSpecDetails) {
                                    _productSpecDetails.forEach(detail => {
                                        _specValue += (detail.detailValue + "/")
                                    })
                                }
                                item.specValue = _specValue
                            })
                        }
                    })
                }
                this.shopIndexInfo.products = data
            } catch (error) {
                console.error('Failed to fetch hot products:', error)
            } finally {
                this.loading = false
            }
        },
        async getTodayData() {
            try {
                const params = {
                    page: 1,
                    row: 10,
                    shopId: this.shopId
                }
                const { data } = await getTodayData(params)
                Object.assign(this.shopIndexInfo, data)
                this.initShopUserEcharts()
            } catch (error) {
                console.error('Failed to fetch today data:', error)
            }
        },
        initShopUserEcharts() {
            const dom = document.getElementById("userEchatjs")
            const myChart = echarts.init(dom)
            const option = {
                xAxis: {
                    type: 'category',
                    data: [...this.shopIndexInfo.sevenDay].reverse()
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: [...this.shopIndexInfo.sevenDayDatas].reverse(),
                    type: 'line',
                    smooth: true
                }]
            }
            if (option && typeof option === "object") {
                myChart.setOption(option, true)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.shop-index-container {
    .data-card {
        border-radius: 4px;
    }

    .chart-card {
        margin-bottom: 20px;
        border-radius: 4px;
    }

    .margin-top {
        margin-top: 20px;
    }

    .margin-bottom-lg {
        margin-bottom: 20px;
    }

    .margin-top-lg {
        margin-top: 20px;
    }

    .text-center {
        text-align: center;
    }
}
</style>